import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isMobile } from "../../../../helpers";

class Dashboard extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentWillMount() {
        if (isMobile()) {
            this.setState({
                isResponsive: true,
            });
        }

        window.location.replace(process.env.REACT_APP_DASHBOARD_URL);

    }

    render() {

        return (
            <div></div>
        );
    }
}

const mapStateToProps = ({ auth }) => ({ ...auth });
export default connect(mapStateToProps)(Dashboard);


// WEBPACK FOOTER //
// ./src/components/App/Views/Account/Dashboard.js